import React, { useState, useEffect } from "react";
import { HubConnectionBuilder } from "@microsoft/signalr";
import { connect } from "react-redux";
import "./MessageClientModal.css";
import { Button } from "semantic-ui-react";
import { formatDateTimeSec } from "../../../../utils/dateFormatUtil";
import ReviewEndpoints from "../../../../lib/review/ReviewEndpoints";
import { MESSAGEHUB_PATH } from "../../../../utils/Constants";
import { ApplicationMode } from "../../../../lib/store/types/ApplicationStateTypes";

class ClientMetadata {
  constructor(receiverId, receiverGroup) {
    this.receiverId = receiverId;
    this.receiverGroup = receiverGroup;
  }
}

const MessageClientModal = (props) => {
  const [connection, setConnection] = useState(null);
  const [messages, setMessages] = useState([]);
  const [currentMessage, setCurrentMessage] = useState(0);

  useEffect(() => {
    const newConnection = new HubConnectionBuilder()
      .withUrl(MESSAGEHUB_PATH)
      .withAutomaticReconnect()
      .build();
    setConnection(newConnection);

    newConnection.onclose(() => {
      console.log(
        "[MessageClientModal] Connection to server shut down, not able to reconnect. Refresh page."
      );
    });
    newConnection.onreconnecting(() => {
      console.log("[MessageClientModal] Trying to reconnect...");
    });
  }, []);

  useEffect(() => {
    if (connection && props.loginState.workstationID > -1) {
      connection.onreconnected((connectionId) => {
        console.log("[MessageClientModal] Reconnected");
        if (connection) {
          sendClientMetadata();
        }
      });

      connection
        .start()
        .then((result) => {
          try {
            sendClientMetadata();
          } catch (err) {
            console.error(err);
          }

          connection.on("ReceiveMessage", (message) => {
            upsertMessage(message);
          });

          connection.on("DeleteMessage", (message) => {
            message.title += " (Löst)";
            message.type = "SolvedMessage";
            updateMessage(message);
          });
        })
        .catch((e) => console.log("Connection failed: ", e));
    }
  }, [connection, props.loginState.workstationID]);

  function sendClientMetadata() {
    let metadata = new ClientMetadata("ws" + props.loginState.workstationID, "kontrollstationer");
    connection.invoke("SendClientMetadata", metadata);
  }

  function upsertMessage(message) {
    var flash = false;
    setMessages((messages) => {
      const tmpMessages = [...messages];
      const existingMessageIndex = tmpMessages.findIndex((msg) => msg.id == message.id);

      if (existingMessageIndex >= 0) {
        // update
        tmpMessages[existingMessageIndex] = message;
        return [...tmpMessages];
      } else {
        if (message.active === true) {
          // insert
          if (message.type === "Alert") {
            tmpMessages.unshift(message);
            setCurrentMessage(0);
          } else {
            tmpMessages.push(message);
          }
          flash = true;
        }
        return [...tmpMessages];
      }
    });
    if (flash) {
      flashMessage();
    }
  }

  function updateMessage(message) {
    if (message.active) {
      const tmpMessages = [...messages];

      var messageIndex = tmpMessages.findIndex((msg) => msg.id == message.id);
      if (messageIndex >= 0) {
        tmpMessages[messageIndex] = message;
      }
      setMessages(tmpMessages);
      flashMessage();
    }
  }

  function tryToAcknowledgeMessage() {
    let id = messages[currentMessage].id;
    return ReviewEndpoints.ackValidationMsg(id).then((result) => {
      hideMessage();
      return result === "OK";
    });
  }

  function hideMessage() {
    let id = messages[currentMessage].id;
    const tmpMessages = [...messages];
    tmpMessages.splice(currentMessage, 1);

    if (tmpMessages.length > 0 && currentMessage >= tmpMessages.length - 1) {
      setCurrentMessage(tmpMessages.length - 1);
    }
    setMessages(tmpMessages);
  }

  function previousMessage() {
    if (currentMessage > 0) {
      setCurrentMessage(currentMessage - 1);
    }
  }
  function nextMessage() {
    if (currentMessage < messages.length - 1) {
      setCurrentMessage(currentMessage + 1);
    }
  }

  function flashMessage() {
    const e = document.getElementsByClassName("MessageClient")[0];
    if (e) {
      setTimeout(function () {
        e.classList.add("NewMessage");
      }, 200);
      setTimeout(function () {
        e.classList.remove("NewMessage");
      }, 4000);
    }
  }

  function getCssType(message) {
    var alertType =
      message.type == "Alert" ? "Alert" : message.type == "Warning" ? "Warning" : "Information";
    alertType = message.active ? alertType : "SolvedMessage";
    return alertType;
  }

  return (
    <div>
      {messages.length > 0 && (
        <div
          className={`MessageClient MessageClientType_${getCssType(messages[currentMessage])}`}
          id={messages[currentMessage].id}
        >
          <div className="MessageClientHeader">
            <h3 className="MessageClientTitle">{messages[currentMessage].title}</h3>
            {messages[currentMessage].active === true ? (
              ""
            ) : (
              <Button
                size="tiny"
                positive
                onClick={hideMessage}
                className="MessageClientHideButton"
              >
                Dölj
              </Button>
            )}
          </div>

          <div className="MessageClientContent">
            {messages[currentMessage].content}
            <div className="MessageClientSender">
              [{messages[currentMessage].sender}]{" "}
              {!!messages[currentMessage].created &&
                formatDateTimeSec(messages[currentMessage].created)}
            </div>
          </div>

          <div className="MessageClientFooter">
            <div className="MessageClientPagination">
              <div onClick={previousMessage} className="MessageClientPreviousMessage">
                Föregående
              </div>
              <div>
                <span className="MessageClientCurrentMessage">{currentMessage + 1}</span> av{" "}
                <span className="MessageClientMessageCount">{messages.length}</span>
              </div>
              <div onClick={nextMessage} className="MessageClientNextMessage">
                Nästa
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default connect(
  (state) => ({
    loginState: state.loginInfoReducer,
  }),
  null
)(MessageClientModal);
